import { ChatDetailsResponse } from '@choco-admin/types';
import { Card, CardBody, CardHeader, Divider } from '@heroui/react';
import React from 'react';
import { FiUsers, FiTruck, FiShoppingBag } from 'react-icons/fi';

import { isRequestedChat } from '../../../../utils/requestedChatLifecycle';
import { PageHeader } from '../PageHeader';

import { BuyerSection } from './participants/BuyerSection';
import { BuyerUsersSection } from './participants/BuyerUsersSection';
import { RequestedChatLifecycle } from './participants/RequestedChatLifecycle';
import { SupplierSection } from './participants/SupplierSection';
import { SupplierUsersSection } from './participants/SupplierUsersSection';

interface ParticipantsTabPanelProps {
  chatData: ChatDetailsResponse;
  chatId: string;
}

export const ParticipantsTabPanel: React.FC<ParticipantsTabPanelProps> = ({
  chatData,
  chatId,
}) => {
  return (
    <div className="space-y-6">
      <PageHeader
        title="Chat Participants"
        subtitle="Manage the buyer, distributor, and users involved in this chat."
        icon={<FiUsers className="w-6 h-6 text-primary" />}
      />

      {/* Requested-chat fulfilment: guidance + explicit activation (#123) */}
      {isRequestedChat(chatData.status) && (
        <RequestedChatLifecycle chatData={chatData} chatId={chatId} />
      )}

      {/* Two Column Layout */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {/* Supplier Section */}
        <Card className="border border-default-200">
          <CardHeader className="pb-3">
            <div className="flex items-center gap-2">
              <FiTruck className="w-5 h-5 text-primary" />
              <h3 className="text-lg font-semibold text-foreground">
                Distributor
              </h3>
            </div>
          </CardHeader>
          <Divider />
          <CardBody className="pt-4 space-y-6">
            <SupplierSection chatData={chatData} chatId={chatId} />
            <SupplierUsersSection chatData={chatData} chatId={chatId} />
          </CardBody>
        </Card>

        {/* Buyer Section */}
        <Card className="border border-default-200">
          <CardHeader className="pb-3">
            <div className="flex items-center gap-2">
              <FiShoppingBag className="w-5 h-5 text-primary" />
              <h3 className="text-lg font-semibold text-foreground">Buyer</h3>
            </div>
          </CardHeader>
          <Divider />
          <CardBody className="pt-4 space-y-6">
            <BuyerSection chatData={chatData} chatId={chatId} />
            <BuyerUsersSection chatData={chatData} chatId={chatId} />
          </CardBody>
        </Card>
      </div>
    </div>
  );
};
